import React from 'react'
import { Input, InputProps } from '../ui/input'
import { InfluencedFileOutputsInterface } from '../../core/interface/chronique.interface'

interface GLFileInputProps extends Omit<InputProps, 'onChange' | 'value'> {
  id: string
  selectedFile: File | null
  onFileChange: (file: File | null) => void
  placeholder: string
  importedFile?: InfluencedFileOutputsInterface[]
}

const GLFileInput: React.FC<GLFileInputProps> = ({
  id,
  selectedFile,
  onFileChange,
  placeholder,
  importedFile = [],
  disabled,
  accept,
  className,
  ...props
}) => {
  const importedFileNames = importedFile.map((file) => file.file_name)
  const displayText =
    selectedFile?.name ||
    (importedFileNames.length > 0 ? importedFileNames.join(', ') : placeholder)

  return (
    <div className="relative flex-1 max-w-md">
      <label
        htmlFor={id}
        className="absolute inset-0 flex items-center px-3 text-sm text-gray-500 bg-white border border-gray-200 rounded-md cursor-text truncate"
      >
        {displayText}
      </label>
      <Input
        id={id}
        type="file"
        accept={accept}
        onChange={(e) => {
          const file = e.target.files?.[0] || null
          onFileChange(file)
        }}
        className="relative z-10 w-full opacity-0"
        disabled={disabled}
        {...props}
      />
    </div>
  )
}

export default GLFileInput
